<template>
  <jw-modal :visible="data.visible" popup-container="body" :mask-closable="false" :okText="$t('保存')" @ok="handleOk" @cancel="handleCancel" title-align="start" width="520px" class="field-list-config-com">
    <template #title> {{ props.title }} </template>
    <div :class="['select-field-list-content', `select-field-list-content${randomString}`]">
      <div class="select-field-list-content-top">
        <jw-popover class="select-field-list-content-popover" trigger="click" position="bottom" :popup-container="`.select-field-list-content${randomString}`" @popup-visible-change="popChange">
          <jw-button size="small" type="text" :class="['add-btn', data.popVisibility ? 'select-btn' : '']"
          ><template #icon><icon-plus /></template>{{ $t('添加字段') }}</jw-button
          >
          <template #content>
            <select-list :batchTableKey="batchTableKey" :list="data.allModulesData" :check-ids="data.setChecked" @cb="getCheckedIds" :empty="props.empty" :isonIsShow="true" />
          </template>
        </jw-popover>
        <div class="btn-group" v-if="props.isClear">
          <jw-button type="text" :disabled="data.setChecked.length == getModulesLens" @click="handleChange(true)">全选</jw-button>
          <jw-button type="text" :disabled="data.setChecked.length <= 1" @click="handleChange(false)">清空</jw-button>
        </div>
      </div>

      <field-list :batchTableKey="batchTableKey" :list="data.fieldListAllData" @cb="updateField" :freeze="props.freeze" :empty="props.empty" />
    </div>
  </jw-modal>
</template>

<script setup>
import FieldList from '@/views/setting/sys-fields/page-layout/components/field-list/field-list.vue'; //显示列
import SelectList from '@/views/setting/sys-fields/page-layout/components/select-field/select-field.vue'; //选择字段
import { reactive, computed } from 'vue';
const emits = defineEmits(['cb']);
import _ from 'lodash';
import { tools } from '@/utils/tools';
const randomString = tools.randomString(10);
const props = defineProps({
  title: {
    //标题
    type: String,
    default: '字段配置'
  },
  empty: {
    // 列表是否可以为空(true:可以为空,false不可以为空)
    type: Boolean,
    default: false
  },
  freeze: {
    // 是否支持冻结(false:不支持)
    type: Boolean,
    default: false
  },
  isClear: {
    // 是否支持清空(false:不支持)
    type: Boolean,
    default: false
  },
  batchTableKey: {
    // 批量查找关联 字段key
    type: String,
    default: ''
  }
});
const data = reactive({
  visible: false,
  popVisibility: false,
  fieldListAllData: {}, //130的所有数据
  fieldListModules: [], //下拉搜索字段信息
  allModulesData: [], //可搜索的字段信息
  setChecked: []
});
const popChange = (e) => {
  data.popVisibility = e;
};

// 更新被选中的状态
const updateShowFlag = (checked) => {
  if (!checked && !props?.empty) {
    //清空且不可以为空(选中第一个，或者主属性)
    const getFields = data.fieldListAllData?.modules || [];
    let getCheckedField;

    for (let i = 0; i < getFields.length; i++) {
      const getIteam = getFields[i];
      const findMain = data.setChecked?.find((settingId) => settingId == getIteam.settingId && getIteam?.mainField);
      if (findMain) {
        getCheckedField = getIteam;
        break;
      }
    }

    if (!getCheckedField) {
      //没有找到主属性
      for (let i = 0; i < getFields.length; i++) {
        const getIteam = getFields[i];
        const findNoMain = data.setChecked?.find((settingId) => settingId == getIteam.settingId && getIteam?.fieldType != 27);
        if (findNoMain) {
          getCheckedField = getIteam;
          break;
        }
      }
    }

    const updateFields = getFields?.map((el) => ({
      ...el,
      showField: el.fieldKey == props.batchTableKey ? true : getCheckedField?.mainField ? (el?.mainField ? true : false) : getCheckedField?.settingId == el.settingId ? true : false,
      modules: el.modules?.map((sub) => ({
        ...sub,
        showField: false
      }))
    }));
    data.fieldListAllData.modules = updateFields;
    setCheckedIds();
    return;
  }

  const getFields = data.fieldListAllData?.modules || [];
  getFields?.forEach((el) => {
    el.showField = checked;
    if (el.fieldType == 27) {
      const subModules = el.modules;
      if (Array.isArray(subModules)) {
        subModules?.forEach((sub) => {
          sub.showField = checked;
        });
      }
    }
  });
  if (checked || (!checked && props?.empty)) {
    setCheckedIds();
  }
};
const handleChange = (checked) => {
  updateShowFlag(checked);
};

const setCheckedIds = () => {
  const getFields = data.fieldListAllData?.modules || [];
  data.setChecked = [];
  getFields?.forEach((el) => {
    if (el?.showField) {
      //显示
      data.setChecked.push(el.settingId);
    }
    if (el.fieldType == 27) {
      const subModules = el.modules;
      if (Array.isArray(subModules)) {
        subModules?.forEach((sub) => {
          if (sub?.showField) {
            //显示
            data.setChecked.push(sub.settingId);
          }
        });
      }
    }
  });
};
// 获取字段数据的个数
const getModulesLens = computed(() => {
  let modulesLens = 0;
  data.allModulesData
    ?.filter((f) => f?.type != 40)
    ?.map((m) => {
      modulesLens++;
      if (m?.fieldType == 27 && m?.settings?.length) {
        //子表单
        modulesLens += m?.settings?.length;
      }
    });
  return modulesLens;
});

// 搜索组件向显示列组件同步状态
const getCheckedIds = (getModules) => {
  //   console.log('checkIds-------', getModules, data.fieldListAllData?.modules);
  const modules = data.fieldListAllData?.modules;
  if (!Array.isArray(modules)) return;
  modules.forEach((el) => {
    const findfield = getModules?.modules?.find((mo) => mo.settingId == el.settingId);
    if (el.fieldType === 27) {
      const subModules = el.modules;
      if (Array.isArray(subModules)) {
        subModules.forEach((sub) => {
          const findSubfield = getModules?.modules?.find((mo) => mo.settingId == sub.settingId);
          if (findSubfield) {
            sub.showField = findSubfield.showField;
          }
        });
        // 检查是否有显示的子字段
        const hasVisibleSubField = subModules.some((subElement) => subElement.showField === true);
        // 检查是否所有子字段都隐藏
        const allSubFieldsHidden = subModules.every((subElement) => subElement.showField === false);

        el.showField = hasVisibleSubField && !allSubFieldsHidden;
      }
    } else {
      if (findfield) {
        el.showField = findfield.showField;
      }
    }
  });
  setCheckedIds();
};
// 列表项同步
const updateField = (fieldList) => {
  data.fieldListAllData = fieldList;

  setCheckedIds();
};
// fieldList参数是一个对象需要包含（modules：选中的字段列表，allModules：可搜索的所有字段列表）
const open = (fieldList) => {
  data.visible = true;
  data.fieldListAllData = _.cloneDeep(fieldList);
  data.fieldListModules = data.fieldListAllData?.modules;
  data.allModulesData = data.fieldListAllData?.allModules;

  //   console.log("data.allModulesData", data.allModulesData);
  setCheckedIds();
  // console.log('获取数据', data.fieldListAllData, props.fieldList);
};
const handleOk = () => {
  emits('cb', data.fieldListAllData);
  data.visible = false;
};
const handleCancel = () => {
  emits('cb', null);
  data.visible = false;
};
// 抛出方法
defineExpose({
  open
});
</script>

<style scoped lang="less">
@import './field-config.less';
</style>
<style lang="less">
.field-list-config-com {
  .arco-modal-wrapper {
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .arco-modal {
    top: 0 !important;
    display: flex;
    flex-direction: column;
    height: 600px;
  }

  .arco-modal-title {
    font-weight: bold;
    font-size: 14px;
  }

  .arco-modal-body {
    // height: 500px;
    // overflow-y: scroll;
    flex: 1;
    width: 100%;
    padding: 16px 0 8px 8px;
  }

  .arco-modal-footer {
    padding: 8px 16px;
  }

  .arco-trigger-popup {
    top: 28px !important;
    right: 16px !important;
    left: 8px !important;
  }

  .arco-popover-popup-content {
    padding: 16px 0 16px 16px;
  }

  .arco-trigger-content {
    display: flex;
    flex-direction: column;
    height: 380px;
  }

  .arco-popover-content {
    height: 100%;
  }

  .arco-popover-popup-arrow {
    display: none;
  }

  .arco-popover-content {
    height: 100%;
  }
}
</style>
